import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { logout } from "../../store/slices/authSlice";
import { openLogin } from "../../store/slices/uiSlice"; 
import Button from "../Button";
import Navigation from "../Navigation";
import NotificationBell from "../NotificationBell";

function Header() {
    const navigate = useNavigate();

    const dispatch = useAppDispatch();
    const { user } = useAppSelector((state) => state.auth);
    const goHome = () => {
        navigate("/");
    };

    const handleOpenLogin = () => {
        dispatch(openLogin()); 
    };

    const handleLogout = () => {
        navigate("/");
        dispatch(logout({ userId: String(user.id) })); 
    };
    return (
        <header className="flex items-center flex-col lg:flex-row w-full h-header bg-brand py-[20px] px-[20px] fixed top-0 left-0 right-0 z-50 lg:h-[75px] lg:justify-between lg:px-[60px]">
            {/* Logo */}
            <div className="flex justify-center items-center mb-[10px] lg:mb-0">
                <i
                    onClick={goHome}
                    className="fas fa-graduation-cap text-accent w-[30px] h-[24px] text-[25px] cursor-pointer"
                ></i>
                <h1
                    onClick={goHome}
                    className="ml-[10px] text-white text-[24px] font-[700] cursor-pointer"
                >
                    TRUNG TÂM TRI THỨC SỐ
                </h1>
            </div>
            <Navigation />
            <div className="mt-[16px] lg:mt-0 flex items-center">
                {user ? (
                    <><NotificationBell /><Button
                        label="Đăng xuất"
                        styleButton="w-[140px] h-[45px]"
                        onClick={handleLogout} 
                    /></>
                ) : (
                    <Button
                        label="Đăng nhập"
                        styleButton="w-[140px] h-[45px]"
                        onClick={handleOpenLogin}
                    />
                )}

            </div>

        </header>
    );
}

export default Header;
